module.exports = __webpack_public_path__ + "static/media/learn-more-parent-image-0.70fb30ee.jpg";